import React from 'react';
import Sidebar from './Sidebar';
import Footer from './Footer';
import LanguageSwitcher from './LanguageSwitcher';
import Clock from './Clock';

function Layout({ children }) {
    return (
        <div style={{
            display: 'flex',
            minHeight: 'var(--app-vh, 100vh)',
            background: 'var(--bg-primary)',
        }}>
            <Sidebar />
            <main className="main-content">
                {/* Thin top bar holding the live local clock + language switcher,
                    right-aligned. A real (non-absolute) row so it never overlaps page
                    headers / action buttons that also sit top-right. Kept slim to
                    avoid a big empty band. */}
                <div className="admin-topbar" style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: '0.85rem',
                    padding: '0.6rem 2rem 0',
                }}>
                    <Clock />
                    <div style={{ width: 1, height: 18, background: 'var(--border-subtle)' }} />
                    <LanguageSwitcher align="right" direction="down" />
                </div>
                <div className="main-content-inner" style={{ paddingTop: '0.5rem' }}>
                    {children}
                </div>
                <Footer />
            </main>
        </div>
    );
}

export default Layout;
